// extracted by mini-css-extract-plugin
export default {"searchInput":"SignedDocuments_searchInput__KZ4XV","searchIcon":"SignedDocuments_searchIcon__RrvnC"};